var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticStyle:{"margin-top":"65px"}},[_c('v-container',{style:({
        'background-image': 'url(' + require('@/assets/RegisterPage.png') + ')',
        'background-position': 'bottom right',
        'padding-bottom': '50px',
        'background-size':'contain',
        'height': '100%'
      }),attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"d-flex pt-7 justify-center",attrs:{"cols":"12"}},[_c('v-card',{staticStyle:{"background":"#FFFFFF","box-shadow":"0px 0px 20px rgba(0, 0, 0, 0.05)","border-radius":"20px","max-width":"1200px","width":"100%"}},[_c('create-organization-form')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }